import React from 'react';
import { twMerge } from 'tailwind-merge';

interface CalendarProps {
  className?: string;
  width?: number;
  height?: number;
}

const CalendarIcon = function CalendarIcon({
  className,
  width,
  height,
}: CalendarProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <rect className={twMerge(className, 'fill-transparent')} x="3" y="6" width="18" height="15" rx="2" stroke="#222222" />
      <path className={twMerge(className, 'fill-transparent')} d="M3 11L21 11" stroke="#222222" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-transparent')} d="M9 16H15" stroke="#222222" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-transparent')} d="M8 3L8 7" stroke="#222222" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-transparent')} d="M16 3L16 7" stroke="#222222" strokeLinecap="round" />
    </svg>
  );
};

CalendarIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default CalendarIcon;
